import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, timer } from "rxjs";
import { catchError, retry } from "rxjs/operators";

@Injectable()
export class RepeatInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            retry({
                count: 4,
                delay: (error, retryCount) => timer(3000)
            }),
            catchError(error => {
                return throwError(() => error);
            })
        );
    }
}
